class SvDetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('sv-details-disclosure', SvDetailsDisclosure);

class HeaderMenu extends SvDetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');

    this.addEventListener('mouseenter', this.onHoverOpen.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));

    // Close when the cursor leaves the whole header (top bar + mega menu panel),
    // rather than just this menu item. The panel is a descendant of .header-wrapper,
    // so moving from the header onto the panel does not count as leaving and keeps it open.
    if (this.header) this.header.addEventListener('mouseleave', this.onHeaderLeave.bind(this));
  }

  onSummaryClick(event) {
    // On desktop the menu is controlled by hover, so prevent the click from toggling it.
    if (this.desktopMediaQuery.matches) event.preventDefault();
  }

  onHoverOpen() {
    if (!this.desktopMediaQuery.matches) return;
    this.closeSiblingMenus();
    this.open();
  }

  onHeaderLeave() {
    if (!this.desktopMediaQuery.matches) return;
    if (this.mainDetailsToggle.hasAttribute('open')) this.close();
  }

  closeSiblingMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && typeof menu.close === 'function') menu.close();
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
    this.updateHeaderMenuOpenState();
  }

  close() {
    super.close();
    this.updateHeaderMenuOpenState();
  }

  // Keep the header's opaque (menu-open) state in sync when opening/closing via hover.
  // Mirrors setupMenuOpenWatcher in global.js, but runs synchronously so the transparent
  // header turns opaque as soon as a mega menu opens on hover.
  updateHeaderMenuOpenState() {
    const sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader) return;
    sectionHeader.classList.toggle('menu-open', sectionHeader.querySelector('details[open]') !== null);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
